import MainLayout from '@/shared/layout/main-layout';
import Dashboard from './dashboard';

const routes = [
  {
    path: '/dashboard',
    component: MainLayout,
    meta: { auth: true },
    children: [
      {
        name: 'dashboard',
        path: '',
        component: Dashboard,
        meta: { auth: true },
      },
    ],
  },
];

export default {
  routes,
};



// WEBPACK FOOTER //
// ./src/dashboard/dashboard-module.js